import React, { useState } from 'react';
import PropType from 'prop-types';

import Header from './Header';
import Content from './Content';
import Footer from './Footer';

import { StyledCheckBox } from './Styles';
import { HeaderType } from '../../constants/filters';

const propTypes = {
  filterList: PropType.objectOf(PropType.object).isRequired,
  headerType: PropType.oneOf([HeaderType.Controlled, HeaderType.Base]),
  headerTitle: PropType.string,
  openPopOver: PropType.func.isRequired,
  searchEnabled: PropType.bool,
  searchPlaceHolder: PropType.string,
  allSelectedText: PropType.string,
  hasChild: PropType.bool,
  handleFilterApply: PropType.func.isRequired,
  testId: PropType.string
};

const defaultProps = {
  headerType: undefined,
  headerTitle: '',
  searchPlaceHolder: '',
  allSelectedText: '',
  hasChild: false,
  searchEnabled: false,
  testId: undefined
};

/**
 * Returns the total number of items in the list
 */
function initializeNumItems(list, hasChild) {
  if (hasChild) {
    return Object.keys(list).reduce(
      (accumulator, currentValue) =>
        accumulator + list[currentValue].children.length,
      0
    );
  }
  return Object.keys(list).length;
}

/**
 * Returns the total number of child items selected
 */
function initializeNumChildItemsSelected(list, hasChild) {
  let noSelected = 0;

  if (hasChild) {
    Object.keys(list).forEach(id => {
      list[id].children.forEach(model => {
        if (model.isSelected) {
          noSelected += 1;
        }
      });
    });
  } else {
    Object.keys(list).forEach(id => {
      noSelected += list[id].isSelected;
    });
  }

  return noSelected;
}

const CheckBoxFilter = ({
  filterList,
  headerType,
  headerTitle,
  openPopOver,
  searchEnabled,
  searchPlaceHolder,
  allSelectedText,
  hasChild,
  handleFilterApply,
  shouldNotTranslate,
  testId
}) => {
  const [list, setList] = useState(filterList);
  const [dirtyList, setDirtyList] = useState({});
  const [isDirty, setIsDirty] = useState(false);

  const [numItems] = useState(initializeNumItems(list, hasChild));
  const [numItemsSelected, setNumItemsSelected] = useState(
    initializeNumChildItemsSelected(list, hasChild)
  );

  const applyFilter = () => {
    openPopOver(false);

    // Check if no item in the list is selected and it is not a nested filter
    // then select all items in the list as a list cannot have zero items selected
    if (numItemsSelected === 0 && !hasChild) {
      Object.keys(list).forEach(id => {
        list[id].isSelected = true;
      });

      setNumItemsSelected(numItems);
    }

    handleFilterApply(list);
  };

  return (
    <StyledCheckBox>
      <Header
        closePopOver={() => openPopOver(false)}
        list={list}
        setList={setList}
        setIsDirty={setIsDirty}
        setDirtyList={setDirtyList}
        headerType={headerType}
        headerTitle={headerTitle}
        searchEnabled={searchEnabled}
        searchPlaceHolder={searchPlaceHolder}
        allSelectedText={allSelectedText}
        numItems={numItems}
        numItemsSelected={numItemsSelected}
        setNumItemsSelected={setNumItemsSelected}
        hasChild={hasChild}
        testId={`${testId}-search-bar`}
      />

      <Content
        list={list}
        dirtyList={dirtyList}
        setList={setList}
        setDirtyList={setDirtyList}
        isDirty={isDirty}
        numItems={numItems}
        numItemsSelected={numItemsSelected}
        setNumItemsSelected={setNumItemsSelected}
        hasChild={hasChild}
        shouldNotTranslate={shouldNotTranslate}
        testId={testId}
      />

      <Footer applyFilter={() => applyFilter()} testId={`${testId}-applyBtn`} />
    </StyledCheckBox>
  );
};

CheckBoxFilter.propTypes = propTypes;
CheckBoxFilter.defaultProps = defaultProps;

export default React.memo(CheckBoxFilter);
